import {useEffect} from 'react';
import PropTypes from 'prop-types';

import {useFieldValidationAnnouncement} from '@amblique/king-living/app/hooks/use-field-validation-announcement';

export function FieldValidationStatus({
  enabled,
  errorMessage,
  formatMessage,
  id,
  invalid,
  keyDownRef,
  label,
  value,
}) {
  const {handleKeyDown} = useFieldValidationAnnouncement({
    enabled,
    errorMessage,
    formatMessage,
    invalid,
    label,
    value,
  });

  useEffect(() => {
    if (keyDownRef) {
      keyDownRef.current = handleKeyDown;
    }
  }, [handleKeyDown, keyDownRef]);

  return null;
}

FieldValidationStatus.propTypes = {
  enabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  keyDownRef: PropTypes.shape({current: PropTypes.func}),
  label: PropTypes.string,
  value: PropTypes.any,
};
